module.exports = __webpack_public_path__ + "static/images/bg-one.a31fd22.png";